(function () {
  function renderCount(count) {
    const cartLink = document.getElementById('kk-cart-icon');
    if (!cartLink) return;

    const iconWrap = cartLink.querySelector('.kk-main-header__action-icon');
    if (!iconWrap) return;

    let badge = iconWrap.querySelector('.kk-main-header__cart-count');

    if (!count || count <= 0) {
      if (badge) badge.remove();
      return;
    }

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'kk-main-header__cart-count';
      iconWrap.appendChild(badge);
    }

    badge.textContent = count < 100 ? String(count) : '99+';
  }

  // Expose the renderer so cart.js can update the custom header badge immediately
  // from Shopify's authoritative AJAX cart response, without waiting for pub/sub.
  window.KKCartCountSync = { render: renderCount };

  async function fetchAndRenderCount() {
    try {
      const cartUrl = (typeof routes !== 'undefined' && routes?.cart_url) || '/cart';
      const response = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      const realCount = (cart.items || []).filter((item) => Number(item.variant_id) !== 56907639292244).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
      renderCount(realCount);
    } catch (_) {
      // Leave the current badge untouched if the cart request fails.
    }
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const items = event?.cartData?.items;
        const count = Array.isArray(items)
          ? items.filter((item) => Number(item.variant_id) !== 56907639292244).reduce((sum, item) => sum + Number(item.quantity || 0), 0)
          : undefined;
        if (typeof count === 'number') {
          renderCount(count);
        } else {
          fetchAndRenderCount();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
